module.exports = __webpack_public_path__ + "static/img/gopay-2-mobile-bg.83c8427.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gopay/gopay-2-mobile-bg.png
// module id = nngK
// module chunks = 1